const sessionStorageClient = window.sessionStorage;

export default sessionStorageClient;
